module.exports = __webpack_public_path__ + "static/media/lr.4bcc294f.svg";